module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event2/younite-event-ja-a47ec556afb20c3ce0b6056224789b9d.png";